import React from 'react'

import { AuthBackgroundImage } from '../authBackgroundImage/AuthBackgroundImage'

import { Footer } from '@percent/admin-dashboard/common/components'
import { Box, Text } from '@percent/lemonade'
import { ReactComponent as PercentLogo } from '@percent/admin-dashboard/common/assets/images/percentlogo.svg'
import { ReactComponent as AdminDashboardLogo } from '@percent/admin-dashboard/common/assets/images/admin_dashboard_logo.svg'
import styles from './AuthView.module.scss'
import { AuthViewProps } from './AuthView.types'

export function AuthView({ heading = '', children, handleSubmit, adminLogo = false }: AuthViewProps) {
  return (
    <Box className={styles.loginPageContainer}>
      <Box className={styles.formContainer}>
        <form onSubmit={handleSubmit} className={styles.form}>
          {adminLogo ? <AdminDashboardLogo /> : <PercentLogo />}
          {heading && <Text className={styles.loginText}>{heading}</Text>}
          {children}
        </form>
      </Box>
      <AuthBackgroundImage />
      <Footer />
    </Box>
  )
}
